export const FEATURE_WEEKLY_GOALS = false;
export const FEATURE_TEAM_DASHBOARD = false;
export const FEATURE_PROSPECTS = false;

export const FEATURES = {
  WEEKLY_GOALS: FEATURE_WEEKLY_GOALS,
  TEAM_DASHBOARD: FEATURE_TEAM_DASHBOARD,
  PROSPECTS: FEATURE_PROSPECTS
};
